import { useDeliveryApi } from 'infrastructure/api';
import { ResourceData, useCrudService } from 'framework/crud';
import { cloneDeep } from 'lodash';
import { MilestonesType } from './types';
import milestonesArrayValidation, {
  completeMilestoneValidation,
  milestonesDashboardValidation,
  rejectMilestoneValidation,
} from './milestonesValidation';

export const MILESTONES_ALIAS = {
  ADVANCED_PAYMENT: 'ADVANCED_PAYMENT',
  PROGRESS_BILLING: 'PROGRESS_BILLING',
  ACCEPTANCE_MILESTONE: 'ACCEPTANCE_MILESTONE',
  NON_BILLING_MILESTONE: 'NON_BILLING_MILESTONE',
};

export const MILESTONES_LABELS = {
  ADVANCED_PAYMENT: 'Advance payment',
  PROGRESS_BILLING: 'Progress billing',
  ACCEPTANCE_MILESTONE: 'Acceptance milestone',
  NON_BILLING_MILESTONE: 'Non-billing milestone',
};

const useMilestonesService = () => {
  const singleResourceUrl = '/projects/:id';
  const {
    search: baseSearch,
    update: initialUpdate,
    ...baseCrudRequests
  } = useCrudService({
    singleResourceUrl,
    listResourceUrl: '/projects',
    useService: useDeliveryApi,
  });

  const { sendPostRequest, sendPutRequest } = useDeliveryApi();

  const milestonesSearch = async (id: string, request: ResourceData) => {
    const searchParams = cloneDeep(request);
    const response = await sendPostRequest(`/projects/${id}/milestones/search`, searchParams);
    return response.json();
  };

  const completeMilestone = async (milestoneId: string, data: void | object): Promise<void | object> => {
    const response = await sendPutRequest(`/projects/milestones/${milestoneId}/complete`, data);
    return response.json();
  };

  const rejectMilestone = async (milestoneId: string, data: void | object): Promise<void | object> => {
    const response = await sendPutRequest(`/projects/milestones/${milestoneId}/reject`, data);
    return response.json();
  };

  const milestonesBatch = async (id: string, data: MilestonesType[]): Promise<MilestonesType[]> => {
    const res = await sendPostRequest(`/projects/${id}/milestones/batch`, { batch: data });
    return res.json();
  };

  const getMilestonesValidationSchema = () => Promise.resolve(milestonesArrayValidation);
  const getMilestonesOnDashboardValidationSchema = () => Promise.resolve(milestonesDashboardValidation);
  const getCompleteMilestoneValidationSchema = () => Promise.resolve(completeMilestoneValidation);
  const getRejectMilestoneValidationSchema = () => Promise.resolve(rejectMilestoneValidation);

  return {
    ...baseCrudRequests,
    milestonesSearch,
    completeMilestone,
    rejectMilestone,
    milestonesBatch,
    getMilestonesValidationSchema,
    getCompleteMilestoneValidationSchema,
    getRejectMilestoneValidationSchema,
    getMilestonesOnDashboardValidationSchema,
  };
};

export default useMilestonesService;
